<template>
  <!--司法信息-->
  <div style="margin-bottom:16px;">
    <a-divider></a-divider>
    <div style="padding-bottom:20px;">
      <h3>被执行人</h3>
      <TableView
        :columns="columnsInfo1"
        :data="personSubjectToEnforcement"
        :pagination="pageData"
        @handlePagination="handlePagination"
        :loading="loading"
        :bordered="bordered"
        :scroll="scroll"
        :rowKey="rowKey"
      ></TableView>
    </div>
    <div style="padding-bottom:20px;">
      <h3>失信被执行人</h3>
      <TableView
        :columns="columnsInfo2"
        :data="defaulter"
        :pagination="pageData"
        @handlePagination="handlePagination"
        :loading="loading"
        :bordered="bordered"
        :scroll="scroll"
        :rowKey="rowKey"
      >
        <template v-slot:titleRender="{ tableRow }">
          <a-button
            type="link"
            size="small"
            @click="handleView(tableRow.content)"
          >
            查看详情
          </a-button>
        </template>
      </TableView>
    </div>
    <div style="padding-bottom:20px;">
      <h3>开庭公告</h3>
      <TableView
        :columns="columnsInfo3"
        :data="announcementOfCourtSession"
        :pagination="pageData"
        @handlePagination="handlePagination"
        :loading="loading"
        :bordered="bordered"
        :scroll="scroll"
        :rowKey="rowKey"
      ></TableView>
    </div>
  </div>
</template>
<script>
import mixin from './mixin-info'
import { TableView } from '@/lxfintech-fe-components'
import { getJusticeInfo } from './api.js'
export default {
  components: { TableView },
  mixins: [mixin],
  data() {
    return {
      rowKey: 'id',
      scroll: { x: 1300 },
      tableData: [],
      loading: true,
      bordered: true,
      pageData: {
        current: 1, //当前页
        pageSize: 10, //每页显示数量
        total: 0, //总共数量,
        showTotal: total => `总共 ${total} 条`, //展示总条数
      },
      enterpriseName: '',
      personSubjectToEnforcement: [],
      defaulter: [],
      announcementOfCourtSession: [],
      content: '',
    }
  },
  mounted() {
    const params = {
      enterpriseName: this.$store.getters['app/company'].name,
      // enterpriseName: '合肥胜利精密科技有限公司'
    }
    this._getJusticeInfo(params)
  },
  methods: {
    async _getJusticeInfo(params) {
      const {
        resultData: {
          personSubjectToEnforcement,
          defaulter,
          announcementOfCourtSession,
        },
      } = await getJusticeInfo(params)
      //this.$emit('loadingFalse')
      this.loading = false
      this.personSubjectToEnforcement = personSubjectToEnforcement
      this.defaulter = defaulter
      this.announcementOfCourtSession = announcementOfCourtSession
    },
    // 分页
    handlePagination(pagination) {
      ;({
        current: this.pageData.current,
        pageSize: this.pageData.pageSize,
        total: this.pageData.total,
      } = pagination)
    },
    //查看
    handleView(content) {
      this.content = content.split('<br/>')
      this.visible = true
    },
  },
}
</script>
